var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('Loading'):(_vm.error)?_c('div',{staticClass:"notification is-danger"},[_vm._v(_vm._s(_vm.error))]):_vm._t("default",null,{"data":_vm.data,"fetch":_vm.fetch})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }